module.exports = __webpack_public_path__ + "img/1.e5f90c5f.jpg";